<div class="page">
  <app-navbar />
  <div class="page-wrapper">
    <div class="page-body">
      <div class="container-xl">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
